import React from 'react';

const Footer = () => {
  return (
    <footer className="border-t border-gray-200 dark:border-slate-700 bg-white dark:bg-slate-900 mt-auto">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          {/* Logo and Brand */}
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-gradient-to-br from-emerald-500 to-emerald-600 shadow-sm">
              <img 
                src="/assets/images/RBS_LOGO_23_2_-1768354637228.png" 
                alt="Pacific RBS Ltd Logo" 
                className="h-8 w-8 object-contain"
              />
            </div>
            <div className="flex flex-col">
              <span className="text-sm font-semibold text-gray-900 dark:text-white">Pacific RBS Ltd</span>
              <span className="text-xs text-gray-500 dark:text-gray-400">Professional HR Solutions</span>
            </div>
          </div>

          {/* Footer Links */}
          <div className="flex items-center gap-6 text-sm text-gray-600 dark:text-gray-400">
            <a href="mailto:admin@hrpacificrbs.com" className="hover:text-emerald-600 dark:hover:text-emerald-400 transition-colors">
              Contact Support
            </a>
            <span className="text-gray-300 dark:text-gray-600">|</span>
            <span>© {new Date()?.getFullYear()} Pacific RBS Ltd</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;